import type { ComponentProps } from 'react';

import { Translate, TranslateHtml, useI18n } from '@change-corgi/core/react/i18n';
import { Link, Text } from '@change-corgi-ds-v2/core-ui';
import {
	FooterLayout,
	FooterLayoutBottom,
	FooterLayoutCopyright,
	FooterLayoutLanguageSwitcher,
	FooterLayoutSection,
} from '@change-corgi-ds-v2/layout';

import { useFooter } from './hooks/useFooter';

export const Footer: React.FC<ComponentProps<'div'>> = (props) => {
	const {
		data: { links, currentLocale, locales, currentYear },
		actions: { handleLocaleChange },
	} = useFooter();
	const { translate } = useI18n();

	return (
		<FooterLayout {...props}>
			{links.map((linkGroup) => (
				<FooterLayoutSection key={linkGroup.title} title={linkGroup.title}>
					{linkGroup.links.map((link) => (
						<Link key={link.title} href={link.href} variant="primary" underline={false}>
							{link.title}
						</Link>
					))}
				</FooterLayoutSection>
			))}
			<FooterLayoutBottom>
				<FooterLayoutLanguageSwitcher
					defaultLanguage={currentLocale}
					languages={locales}
					onChange={handleLocaleChange}
					ariaLabel={translate('fe.components.footer.locale')}
				/>
				<FooterLayoutCopyright>
					<Text fontWeight="bold" size="small">
						<Translate value="fe.components.footer.copyright" replacements={{ year: currentYear }} />
					</Text>
					<Text size="small">
						<TranslateHtml
							value="fe.components.footer.recaptcha.branding_text"
							replacements={{
								googlePrivacyPolicyLink: (
									<Link href="https://policies.google.com/privacy" target="_blank">
										<Translate value="fe.components.footer.recaptcha.privacy_policy_link_text" />
									</Link>
								),
								googleToSLink: (
									<Link href="https://policies.google.com/terms" target="_blank">
										<Translate value="fe.components.footer.recaptcha.terms_of_service_link_text" />
									</Link>
								),
							}}
						/>
					</Text>
				</FooterLayoutCopyright>
			</FooterLayoutBottom>
		</FooterLayout>
	);
};
